import React from 'react';
import PropTypes from 'prop-types';
import { OrderedMap } from 'immutable';

import { imageCdnAsset, imageCdnAssetSet } from 'lib/common/url-helpers';
import { hasBusinessProfile } from 'models/payment-method';
import Brand from 'models/brand';

const propTypes = {
  paymentMethods: PropTypes.instanceOf(OrderedMap).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  onClick: PropTypes.func.isRequired,
};

const BusinessProfileAd = ({ paymentMethods, brand, onClick }) => {
  if (hasBusinessProfile(paymentMethods) || !brand.showBusinessPaymentMethods) { return null; }

  return (
    <div className="row">
      <div className="col-xs-12 hidden-lte-sm">
        <img
          className="with-bottom-margin-2x heavy-shadowed clickable"
          onClick={onClick}
          src={imageCdnAsset('/images/promos/business-profile-promo.png')}
          srcSet={imageCdnAssetSet('/images/promos/business-profile-promo.png 830w, /images/promos/business-profile-promo@2x.png 1660w, /images/promos/business-profile-promo@3x.png 2495w')}
          alt="Add a Business Profile"
        />
      </div>
    </div>
  );
};

BusinessProfileAd.propTypes = propTypes;

export default BusinessProfileAd;
